export default "__VITE_ASSET__CLFYxXDd__"